import styled from 'styled-components';
import { Close as CloseIcon } from '@mui/icons-material';

export const IconClose = styled(CloseIcon)`
  &&& {
    cursor: pointer;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 300px;
  overflow: auto;
`;
